import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";
import InvitationTemplateOptionsPanel from "./InvitationTemplateOptionsPanel";
import SupportArticlePanel from "components/SupportArticlePanel/SupportArticlePanel";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import { InvitationTemplateDetailSection } from "./InvitationTemplateDetailSection";
import { InvitationTemplateActivityPanel } from "./activity/InvitationTemplateActivityPanel";
import { InvoiceTemplateDetailSection } from "invoiceTemplate/detail/InvoiceTemplateDetailSection";
import { EmailTemplateDetailSection } from "emailtemplate/Detail/EmailTemplateDetailSection";

const InvitationTemplateDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.MessageTemplateDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          {viewModel.messageTemplate.section === "invitationTemplate" && <InvitationTemplateDetailSection
            title={viewModel.pageTitle}
            invitationTemplate={viewModel.messageTemplate}
          />}
          {viewModel.messageTemplate.section === "invoiceDocumentTemplate" && <InvoiceTemplateDetailSection
            title={viewModel.pageTitle}
            invoiceDocumentTemplate={viewModel.messageTemplate}
          />}
          {viewModel.messageTemplate.section === "emailTemplate" && <EmailTemplateDetailSection
            title={viewModel.pageTitle}
            emailTemplate={viewModel.messageTemplate}
            mergeFieldTopicLabel={viewModel.mergeFieldTopicLabel}
            availableMergeFieldTopics={viewModel.availableMergeFieldTopics}
          />}
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <InvitationTemplateOptionsPanel
            canDelete={!viewModel.messageTemplate.basicTemplate}
            type={viewModel.type.value}
            optionsPanelData={viewModel.optionsPanel}
            listUrl={viewModel.listUrl}
            templateId={viewModel.messageTemplate.messageTemplateId}
          />
          <SupportArticlePanel config={viewModel.articlePanelConfig} />
          <InvitationTemplateActivityPanel
            invitationTemplateId={viewModel.messageTemplate.messageTemplateId}
            config={viewModel.activityPanel}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>
}

export default InvitationTemplateDetailApp;